export default __webpack_public_path__ + "static/media/human_resources.06a2cae6.png";